<template>
  <div :class="$style['pt-insure-info-form']">
    <pt-page-title title="编辑投保信息"></pt-page-title>
    <pt-sub-title title="投保信息"></pt-sub-title>
    <pt-form-list-item label="监护人姓名:" required  :widthMax="widthMax">
       <wt-input v-model="formValue.guardianName" data-vv-as="监护人姓名"  v-validate="'required'"></wt-input>
    </pt-form-list-item>
    <pt-form-list-item label="监护人性别:" required  :widthMax="widthMax">
       <wt-selector title="监护人性别" :options="options" v-model="formValue.guardianGender" data-vv-as="监护人性别" v-validate="'required'">
        </wt-selector>
    </pt-form-list-item>
    <pt-form-list-item label="监护人身份证号:" required  :widthMax="widthMax">
       <wt-input v-model="formValue.guardianIdentityCard" data-vv-as="监护人身份证号" v-validate="'required'" @change="guardianChange"></wt-input>
    </pt-form-list-item>
    <pt-form-list-item label="监护人出生日期:" required  :widthMax="widthMax">
       <el-date-picker v-model="formValue.guardianBirthdate"  value-format="timestamp" data-vv-as="监护人出生日期" v-validate="'required'"></el-date-picker>
    </pt-form-list-item>
    <pt-form-list-item label="监护人手机号:" required  :widthMax="widthMax">
       <wt-input v-model="formValue.guardianPhone" data-vv-as="监护人手机号" v-validate="'required|phone'"></wt-input>
    </pt-form-list-item>
    <pt-form-list-item label="被保险人（孩子）姓名:" required  :widthMax="widthMax">
       <wt-input v-model="formValue.insurerName" data-vv-as="被保险人（孩子）姓名" v-validate="'required'"></wt-input>
    </pt-form-list-item>
    <pt-form-list-item label="被保险人（孩子）性别:" required  :widthMax="widthMax">
       <wt-selector title="被保险人（孩子）性别" :options="options" v-model="formValue.insurerGender" data-vv-as="被保险人（孩子）性别" v-validate="'required'">
        </wt-selector>
    </pt-form-list-item>
    <pt-form-list-item label="被保险人（孩子）身份证号:" required  :widthMax="widthMax">
       <wt-input v-model="formValue.insurerIdentityCard" @change="insurerChange" data-vv-as="被保险人（孩子）身份证号" v-validate="'required'"></wt-input>
    </pt-form-list-item>
    <pt-form-list-item label="被保险人（孩子）出生日期:" required  :widthMax="widthMax">
      <el-date-picker v-model="formValue.insurerBirthday" value-format="timestamp" data-vv-as="被保险人（孩子）出生日期" v-validate="'required'"></el-date-picker>
    </pt-form-list-item>
    <pt-form-list-item label="户口本监护人页（优先上传母亲页）:" required  :widthMax="widthMax">
      <wt-upload-file :action="uploadApi" :data="picture_params" :img-url="privateResourcesUrl"
      v-model="formValue.householdRegisterHomePage" :multiple="false" data-vv-as="户口本监护人页（优先上传母亲页）" name="name"  v-validate="'required'">
      </wt-upload-file>
    </pt-form-list-item>
    <pt-form-list-item label="请上传被保险人（孩子）页:" required  :widthMax="widthMax">
      <wt-upload-file :action="uploadApi" :data="picture_params" :img-url="privateResourcesUrl"
      v-model="formValue.householdRegisterInsurerPage" :multiple="false" data-vv-as="请上传被保险人（孩子）页" name="name"  v-validate="'required'">
      </wt-upload-file>
    </pt-form-list-item>
    <div v-for="(item,index) in formValue.healthQas" :key="index">
      <pt-form-list-item :label="item.label+':'" required  :widthMax="widthMax" v-if="!index || question1==='B 是'">
        <wt-radio v-if="index===0" :radios="item.options" v-model="question1" :data-vv-as="item.label"
              name="type"  v-validate="'required'"></wt-radio>
        <wt-checkbox v-if="index===1"  :checkList="item.options" v-model="question2" v-validate="'required'" :data-vv-as="item.label" name="name"></wt-checkbox>
      </pt-form-list-item>
    </div>
    <div class="button-div">
      <el-button type="primary" @click="submitData">提交</el-button>
      <el-button type="primary" plain :class="$style['submit-button']" @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
import { getDeleteSpace } from 'utils/formUtils'
// 组件class前缀
const prefixCls = 'pt-insure-info-form'

export default {
  name: 'pt-insure-info-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    insureInfoDetail: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    insureInfoDetail: {
      handler: function (val) {
        if (val.id) {
          this.formValue = { ...val }
          this.question1 = val.healthQas[0].answer[0]
          this.question2 = val.healthQas[1].answer
          this.picture_params.objectId = val.id
        }
      }
    }
  },
  data () {
    return {
      formValue: {

      },
      question1: '',
      question2: [],
      widthMax: '400',
      options: [{ value: 'MALE', label: '男' },
        { value: 'FEMALE', label: '女' }
      ],
      uploadApi: this.$uploadApi,
      privateResourcesUrl: this.$privateResourcesUrl,
      picture_params: {
        resourceName: 'wechat',
        objectId: 0
      }
    }
  },
  methods: {
    cancel () {
      history.go(-1)
    },
    guardianChange (val) {
      this.formValue.guardianIdentityCard = getDeleteSpace(val)
    },
    insurerChange (val) {
      this.formValue.insurerIdentityCard = getDeleteSpace(val)
    },
    submitData () {
      if (this.question1 === 'B 是' && !this.question2.length) {
        this.$message.error('请至少选择一项诊断疾病')
        return
      }
      if (this.question1 === 'A 否') {
        this.question2 = []
      }
      this.validate('formValue').then(formValue => {
        let data = { ...formValue }
        data.healthQas[0].answer = [this.question1]
        data.healthQas[1].answer = this.question2
        this.$emit('updateInsureInfo', data)
      })
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-insure-info-form{
  :global{
    .wt-input{
      width:240px
    }
    .wt-selector,.el-date-editor{
      width:240px
    }
  }
}
</style>
